var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isFiltered)?_c('li',{staticClass:"c-select__list-item",class:{
    'c-select__list-item--selected': _vm.isSelected,
    'c-select__list-item--disabled': _vm.disabled,
  },on:{"click":function($event){$event.stopPropagation();return _vm.clickOption.apply(null, arguments)},"mousedown":function($event){$event.preventDefault();}}},[(_vm.select.isMultiple)?_c('gwb-checkbox',{attrs:{"checked":_vm.isSelected,"color":_vm.color,"disabled":_vm.disabled}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_c('span',[_vm._v(_vm._s(_vm.label))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }